import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { MainMenuScene } from './scenes/MainMenuScene';
import { GameModeSelectScene } from './scenes/GameModeSelectScene';
import { MapSelectScene } from './scenes/MapSelectScene';
import { TutorialScene } from './scenes/TutorialScene';
import { CampaignScene } from './scenes/CampaignScene';
import { LoadingScene } from './scenes/LoadingScene';
import { TurnGameScene } from './scenes/TurnGameScene';
import { PALETTE } from './theme';
import { loadRenderResolution, registerGame } from './ui/renderResolution';

// Desktop (Electron): renderujemy w wybranej rozdzielczości i skalujemy do ekranu
// z zachowaniem proporcji (FIT, wyśrodkowane). Web: bez zmian — wypełniamy okno
// (RESIZE). Mostek `window.gierka` ustawia preload przed tym modułem.
const isDesktop = !!window.gierka?.isDesktop;
const scale: Phaser.Types.Core.ScaleConfig = isDesktop
  ? (() => {
      const res = loadRenderResolution();
      return {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: res.width,
        height: res.height,
      };
    })()
  : {
      mode: Phaser.Scale.RESIZE,
      width: window.innerWidth,
      height: window.innerHeight,
    };

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: PALETTE.bg,
  scale,
  input: { activePointers: 2 },
  pixelArt: false,
  scene: [BootScene, MainMenuScene, GameModeSelectScene, TutorialScene, CampaignScene, MapSelectScene, LoadingScene, TurnGameScene],
  banner: false,
};

const game = new Phaser.Game(config);
if (isDesktop) registerGame(game);

// Right mouse button issues in-game orders, so suppress the browser's default
// context menu across the whole app. Phaser only disables it on the canvas;
// the DOM HUD (panels, in-world unit menu) lives on document.body, so we block
// it document-wide to keep RMB consistent everywhere.
document.addEventListener('contextmenu', (e) => e.preventDefault());

// Dev-only handle for benchmarks (scripts/perf-compare.mjs) and ad-hoc
// debugging. Stripped from production builds — Vite folds the if-block away
// when `import.meta.env.DEV` is false.
if (import.meta.env.DEV) {
  (window as unknown as { __game: Phaser.Game }).__game = game;
}
